import { Component } from "react";
import { AlertTriangle } from "lucide-react";

/**
 * ErrorBoundary — evita que un error de render en un sub-árbol (ej. un icono
 * no importado en el modal de Adjuntos) desmonte TODA la app y deje la pantalla
 * en blanco. Muestra un fallback acotado y permite seguir usando el resto.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }

  componentDidUpdate(prevProps) {
    // Reinicia el boundary cuando cambia la key (ej. al reabrir/recargar)
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div
          className="flex flex-col items-center justify-center gap-2 py-8 text-center text-gray-500"
          data-testid="error-boundary-fallback"
        >
          <AlertTriangle size={28} className="text-amber-500" />
          <p className="text-sm font-medium">{this.props.message || "Ocurrió un error al cargar esta sección"}</p>
        </div>
      );
    }
    return this.props.children;
  }
}
